<template>
  <div class="container">
    <!--
      Dummy Image
      Replacement is necessary after obtaining advertisement information.
    -->
    <div class="row h-100">
      <div id="adDiv" class="col-auto flex-md-fill"  style="margin: 16px; color: white; background-color: #ffffff; text-align: center;"
      :style="isMobile() ? 'margin:0; width:100%;':''">
          <!-- <p style="margin-top: 15%;">ここに広告が入ります。</p> -->
          <div id="ad_area_1" class="mb-3"></div>
          <div id="ad_area_2"></div>
          <div id="ad_area_3" class="d-block d-sm-none mb-3"></div>
          <div id="ad_area_4" class="d-block d-sm-none"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import postscribe from 'postscribe';

  export default {
    name: "AdvertisementPage",
    mounted() {
    }
  }

</script>

<style scoped>
  .container {
    background-color: white;
    width: 100%;
    height: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/AdvertisementPage.vue